import { render } from "./DeleteNodeDialog.vue?vue&type=template&id=4973a276&scoped=true"
import script from "./DeleteNodeDialog.vue?vue&type=script&lang=js"
export * from "./DeleteNodeDialog.vue?vue&type=script&lang=js"

import "./DeleteNodeDialog.vue?vue&type=style&index=0&id=4973a276&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4973a276"]])

export default __exports__